'use client';

import { useSession } from '~hooks/useSession';
export const Client = () => {
	const { isSafeMode } = useSession();
	const text = isSafeMode
		? 'Select a Character to get messages, selfies, videos...'
		: 'Select a character to get messages, selfies, videos and even NSFW\ncontent...';

	return text;
};
